import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  links: {
    '& a': {
      color: `${SecondaryColors.main} !important`,

      '&:hover': {
        color: `${SecondaryColors.light} !important`,
      },
    },
    '& .MuiBreadcrumbs-separator': {
      color: hexToRGBA(TextColors.light, TextOpacities.light3),
    },
  },
};

const lightTheme = {
  links: {
    '& a': {
      color: `${SecondaryColors.dark} !important`,

      '&:hover': {
        color: `${SecondaryColors.dark} !important`,
      },
    },
    '& .MuiBreadcrumbs-separator': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
    },
  },
};

const useStyles = makeStyles(
  () => ({
    links: {
      '& a': {
        fontWeight: 'normal',
      },
    },
  }),
  { name: 'GenBreadcrumb' },
);

export const breadcrumbBoxStyles = makeStyles(
  () => ({
    root: {
      '&.dark-theme': darkTheme.links,
      '&.light-theme': lightTheme.links,
    },
  }),
  { name: 'GenBreadcrumbBox' },
);

export default useStyles;
